module.exports = {"zh-CN":[],"en-US":[],"temp":[{"des":"招聘信息","position":"船长（1名）","req":["需要有10年以上经验需要有10年以上经验需要有10年以上经验需要有10年以上经验","熟悉操作流程","参与过相关气导工作"]},{"des":"招聘信息","position":"软件开发（1名）","req":["需要有10年以上经验","熟悉操作流程","参与过相关气导工作"]},{"des":"招聘信息","position":"船长（1名）","req":["需要有10年以上经验需要有10年以上经验需要有10年以上经验需要有10年以上经验","熟悉操作流程","参与过相关气导工作"]},{"des":"招聘信息","position":"软件开发（1名）","req":["需要有10年以上经验","熟悉操作流程","参与过相关气导工作"]},{"des":"招聘信息","position":"船长（1名）","req":["需要有10年以上经验需要有10年以上经验需要有10年以上经验需要有10年以上经验","熟悉操作流程","参与过相关气导工作"]},{"des":"招聘信息","position":"软件开发（1名）","req":["需要有10年以上经验","熟悉操作流程","参与过相关气导工作"]}]}


//////////////////
// WEBPACK FOOTER
// ./static/json/jobs.json
// module id = VbB9
// module chunks = 0